export default "__VITE_ASSET__DahZeCqO__"